export default __webpack_public_path__ + "static/media/pdf_light.dd65103d.svg";